import http from '../http'
/* --------------权限相关接口------------------ */
/**
 * 获取当前用户可管理权限节点
 */
export const getAuths = () => {
    return http.get('/api/auths')
}
/**
 * 获取当前用户可操作父级节点
 * @param {Number} id 当前权限节点id 0用于添加场景
 */
export const getParentAuths = id => {
    return http.get('/api/auths/parents', { params: { id: id } })
}
/**
 * 获取当前用户可操作权限集合
 * @param {Number} pid 父级权限节点id
 * @param {Number} id 当前权限节点id 0用于添加场景
 */
export const getAuthsData = (pid, id) => {
    return http.get('/api/auths/data', { params: { pid: pid, id: id } })
}

/**
 * 删除权限节点
 * @param {Number} id 节点id
 */
export const deleteAuths = id => {
    return http.delete('/api/auths?id=' + id)
}



// WEBPACK FOOTER //
// ./src/api/main/api-auths.js